export default {
    titulo: "Reparaciones",
    new: "Nueva reparación",
    busqueda: "Buscar por número de orden, equipo o nombre de cliente",
    equiposEntregados: "Equipos entregados",
    compartir: "Compartir detalle de la orden",
    linkDesc: "Link de la orden para el cliente",
    copiarLink: "Copiar",
    msgLinkCopiado: "Se ha copiado el link del detalle de la orden.",
    pregEliminar: "¿Confirmas que deseas eliminar la orden de reparación?",
    labelMotivoEliminar: "Indique el motivo",
    listadoAdjuntos: "Listado de adjuntos",
    msgStep1: "Para continuar con la reparación debes seleccionar un Cliente",
    msgStep2: "Para continuar con la reparación debes seleccionar un Equipo",
    msgStep3: "Para continuar con la reparación debes escribir algún problema del equipo",
    msgStep4: "Para continuar debes seleccionar un técnico.",
    msgEquipoEnTaller: "No puedes agregar este equipo ya que se encuentra en taller en la orden de reparación #",
    tituloVerOrden: "Orden de Reparación #",
    informeMantencion: "Informe de mantención",
    finalizar: "Finalizar",
    entregar: "Entregar",
    imprimirEntrega: "Re-imprimir entrega",
    pregFinalizar: "¿Desea finalizar la orden de reparación?",
    pregEntregar: "¿Desea entregar la orden de reparación?",
    imprimirOrdenFinalizada: "Imprimir reporte de orden finalizada",
    errorEntregada: "No se puede completar la acción porque la orden fue entregada",
    textSeleccionarCliente: "Selecciona una opción para ingresar los datos de un cliente.",
    registrarCliente: "Registrar un nuevo cliente",
    buscarCliente: "Buscar un cliente registrado",
    detallesCliente: "Detalles del cliente",
    noDataCliente: "No se ha seleccionado ningún cliente",
    textOrdenSinEquipo: "Activa esta opción si la orden no tiene un equipo asociado",
    registrarEquipo: "Registrar un nuevo equipo",
    buscarEquipo: "Buscar un equipo registrado",
    detallesEquipo: "Detalles del equipo",
    noDataEquipo: "No se ha seleccionado ningún equipo",
    fechaPrometida: "Fecha prometida de reparación",
    nroManual: "Número de orden manual",
    categoria: "Categoría",
    errorCategoria: "Por favor selecciona una categoría",
    sucursal: "Sucursal",
    errorSucursal: "Por favor selecciona una sucursal",
    depto: "Departamento/Área",
    errorDepto: "Por favor selecciona un departamento/área",
    dineroACuenta: "Entrega de dinero a cuenta",
    errorMonto: "Por favor ingresa un monto válido",
    asignacion: "Asignación de técnico",
    msgAsignacion: "Si asignas la reparación a otra persona se te avisará para que estés al tanto de la nueva tarea que tiene que efectuar",
    usuario: "Usuario",
    grupo: "Grupo",
    seleccionar: "Seleccionar",
    seleccionado: "Seleccionado",
    creando: "Creando reparación",
    hayPlural: "Hay",
    haySingular: "Hay",
    textAgendadosPlural: "Reparaciones prometidas para el",
    textAgendadosSingular: "Reparación prometida para el",
    ingreso: "Ingreso",
    personaContacto: "Persona de contacto",
    asociarEquipo: "Asociar equipo a la orden",
    msgNoHayPermiso: "No tiene permiso para modificar esta orden",
    problema: "Problema reportado",
    editarProblema: "Modificar problema reportado",
    editarFecha: "Modificar fecha prometida",
    tituloEstados: "Estados de la orden",
    msgSinFirmar: "Aún no se ha firmado la orden desde la app",
    aclaracion: "Aclaración",
    documento: "Documento",
    textInforme: "Ingresa el informe de la orden",
    nuevaNota: "Nueva nota",
    eliminarNota: "Eliminar nota",
    pregEliminarNota: "¿Confirmas que deseas eliminar esta nota?",
    presupuesto: {
        manoObra: "Mano de obra",
        rma: "RMA",
        repuestos: "Repuestos",
        entrega: "Entrega a cuenta",
        impuestos: "Impuestos",
        total: "Total del presupuesto",
        email: "Enviar por Email",
        wpp: "Enviar por Whatsapp",
    },
    rma: {
        enviar: "Enviar equipo a RMA",
        recibir: "Recibir equipo",
        nroIntervencion: "Nro. intervención",
        detalle: "Detalle",
        tituloDetalle: "Detalle de equipo en RMA",
        tituloRecibir: "Recibir equipo de RMA",
        msgEquipoEnRma: "El equipo ya se encuentra en RMA",
        btnValidar: "Validar equipo",
        buscarSerie: "Buscar por nro de serie del equipo",
        falla: "Falla",
        fallaLabel: "Falla por la cual se envía"
    },
    estados:{
        "Sin Revisar": "Sin Revisar",
        "En Reparación": "En Reparación",
        "Reparación Terminada": "Reparación Terminada"
    },
    verRegistros: "Ver registros de la orden",
    tituloRegistros: "Registros de la orden de reparación",

}